<template>
  <div class="dict">
    <div class="top-operation">
      <el-button @click="newDataHandle" type="primary">新增舞种</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="id" label="ID" align="center" ></el-table-column>
      <el-table-column prop="name" label="舞种名称" align="right"></el-table-column>
      <el-table-column prop="sort" label="排序" align="right"></el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.updatedAt | formatDate}}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="editRow(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
    <dance-modal ref="danceModal" @loadData="loadData"></dance-modal>
  </div>
</template>

<script>
import DanceModal from './components/DanceModal';
import DanceService from '@/services/activity/dance';
import { formatDate } from '@/utils';
export default {
  data () {
    return {
      tableData: [],
      tableTotal: 0,
    }
  },
  filters: {
    formatDate,
  },
  methods: {
    async initDanceList (params = {}) {
      const { code, message, result: { data, total } } = await DanceService.danceListApi(params);
      if (Object.is(code, 0)) {
        this.tableData = data;
        this.tableTotal = total;
      } else {
        console.error('获取字典列表失败', message);
      }
    },
    // 分页
    handlePageChange (val) {
      this.initDanceList({ pageNumber: val });
    },
    // 新增数据
    newDataHandle () {
      this.$refs.danceModal.openModal();
    },
    loadData () {
      this.initDanceList();
    },
    // 编辑行
    editRow (rowData) {
      this.$refs.danceModal.openModal(rowData);
    },
    deleteRow (rowData) {
      this.$confirm('确认删除？', {
        type: 'warning'
      }).then(async () => {
        const { code, message } = await DanceService.deleteDanceApi(rowData.id);
        if (Object.is(code, 0)) {
          this.$message.success(message);
          this.initDanceList();
        } else {
          this.$message.error(message);
        }
      })
    },
  },
  mounted () {
    this.initDanceList();
  },
  components: {
    DanceModal,
  }
}
</script>

<style lang="scss" scoped>
</style>